module.exports = __webpack_public_path__ + "img/city-silhouette-2.6c47e766.png";